<template>
    <div class="misc-wrapper">
        <b-link class="brand-logo">
            <b-img id="top-bar-logo" :src="`${staticAssetEndpoint}/images/logos/saysimple-dark.svg`" center />
        </b-link>

        <div class="misc-inner p-2 p-sm-3">
            <div class="w-100 text-center">
                <h2 class="mb-1">{{ $t("not-authorized") }}</h2>
                <p class="mb-2">{{ $t("blocked") }}</p>
                <div class="mb-1">
                    <b-button :to="{ path: '/' }" class="mr-1 btn-sm-block" variant="primary">
                        {{ $t("back-to-home") }}
                    </b-button>
                </div>

                <b-img :src="imgUrl" alt="Not authorized page" fluid />
            </div>
        </div>
    </div>
</template>

<script>
import { BButton, BImg, BLink } from "bootstrap-vue";
import store from "@/store";
import { computed, ref } from "@vue/composition-api";

export default {
    components: {
        BLink,
        BImg,
        BButton,
    },
    setup() {
        const downImg = ref(require("@/assets/images/pages/not-authorized.svg"));
        const staticAssetEndpoint = process.env.VUE_APP_MFE_STATIC_ENDPOINT;
        const imgUrl = computed(() => {
            if (store.state.appConfig.layout.skin === "dark") {
                downImg.value = require("@/assets/images/pages/not-authorized-dark.svg");
                return downImg.value;
            }
            return downImg.value;
        });
        return {
            imgUrl,
            downImg,
            staticAssetEndpoint,
        };
    },
};
</script>

<style lang="scss">
@import "~@/@core/scss/vue/pages/page-misc";
</style>
